module.exports = __webpack_public_path__ + "static/media/file.38a59bdb.svg";